import { render, staticRenderFns } from "./DraggableDevice.vue?vue&type=template&id=2ffc8cdb&scoped=true&"
import script from "./DraggableDevice.vue?vue&type=script&lang=js&"
export * from "./DraggableDevice.vue?vue&type=script&lang=js&"
import style0 from "./DraggableDevice.vue?vue&type=style&index=0&id=2ffc8cdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc8cdb",
  null
  
)

export default component.exports